import { render } from "./RemoteControlView.vue?vue&type=template&id=2f58f28f"
import script from "./RemoteControlView.vue?vue&type=script&lang=js"
export * from "./RemoteControlView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__